// import qingsuHome from 'page/qingsu/home.vue'
// import qingsuMy from 'page/qingsu/my.vue'
// import qingsuChannel from 'page/qingsu/channel.vue'
// import moodInsRank from 'page/consult/moodInsRank'
// import zhinan from 'page/qingsu/zhinan'
// const qingsuHome = () =>
//   import(/* webpackChunkName: "qingsuhome" */ 'page/qingsu/home.vue')
// const qingsuHome2 = () =>
//   import(/* webpackChunkName: "qingsuhome" */ 'page/qingsu/homeV2.vue')
// import qingsuIndex from 'page/qingsu/indexV4.vue'

const qingsuMy = () =>
  import(/* webpackChunkName: "qingsumy" */ 'page/qingsu/my.vue')
const qingsuChannel = () =>
  import(/* webpackChunkName: "qingsuchannel" */ 'page/qingsu/channel.vue')

const businessChannel = () =>
  import(
    /* webpackChunkName: "businessChannel" */ 'page/qingsu/businessChannel.vue'
  )

const qingsuFeedback = () =>
  import(
    /* webpackChunkName: "qingsuFeedback" */ 'page/qingsu/qingsuFeedback.vue'
  )

const moodInsRank = () =>
  import(/* webpackChunkName: "moodInsRank" */ 'page/qingsu/moodInsRank.vue')
const zhinan = () =>
  import(/* webpackChunkName: "qingsuzhinan" */ 'page/qingsu/zhinan')
const xinsheng = () =>
  import(/* webpackChunkName: "qingsuzhinan" */ 'page/qingsu/heart')
const qingsuAbtest = () =>
  import(
    /* webpackChunkName: "qingsuabtest" */ 'app/web/page/qingsu/qingsuAbtest.vue'
  )
// const qingsuHomeV3 = () =>
//   import(/* webpackChunkName: "qingsuhomeV3" */ 'page/qingsu/indexV3.vue')

const inviteWithGift = () =>
  import(
    /* webpackChunkName: "inviteWithGift" */ 'page/qingsu/inviteWithGift.vue'
  )

const inviteList = () =>
  import(/* webpackChunkName: "inviteList" */ 'page/qingsu/inviteList.vue')

const qingsuFinish = () =>
  import(/* webpackChunkName: "qingsuFinish" */ 'page/qingsu/qingsuFinish.vue')

const textPackTime = () =>
  import(/* webpackChunkName: "textPackTime" */ 'page/qingsu/textPackTime.vue')

const couponTeacher = () =>
  import(
    /* webpackChunkName: "couponTeacher" */ 'page/qingsu/couponTeacher.vue'
  )

const qingsuIndex = () =>
  import(/* webpackChunkName: "qingsuIndex" */ 'page/qingsu/indexV4.vue')

const packageTeacher = () =>
  import(
    /* webpackChunkName: "packageTeacher" */ 'page/qingsu/packageTeacher.vue'
  )

export default [
  {
    path: '/qingsu',
    component: qingsuIndex,
    meta: {
      business: '倾诉',
      pageName: '倾诉首页V4',
      cache: false
    }
  },
  {
    path: '/qingsu_v4',
    redirect: () => {
      return `/qingsu`
    }
  },
  {
    path: '/qingsu/textPackTime',
    component: textPackTime,
    meta: {
      business: '倾诉',
      pageName: '倾诉畅聊套餐',
      cache: false
    }
  },
  {
    path: '/qingsu/my',
    component: qingsuMy,
    meta: {
      cache: 30000,
      business: '倾诉',
      pageName: '我的倾诉'
    }
  },
  {
    path: '/qingsu/guide',
    component: zhinan,
    meta: {
      cache: false,
      business: '倾诉',
      pageName: '倾诉指南'
    }
  },
  {
    path: '/qingsu/channel',
    component: qingsuChannel,
    meta: {
      business: '倾诉',
      pageName: '倾诉外部渠道页',
      cache: false,
      forceDotCom: true
    }
  },
  {
    path: '/businessQingsu/channel',
    component: businessChannel,
    meta: {
      business: 'B端倾诉',
      pageName: '倾听师列表页',
      cache: false
    }
  },
  {
    path: '/qingsu/moodInsRank',
    component: moodInsRank,
    meta: {
      pageName: '校园推广达人排行榜',
      business: '倾诉'
    }
  },
  {
    path: '/qingsu/heart',
    component: xinsheng,
    meta: {
      pageName: '用户心声',
      business: '倾诉'
    }
  },
  {
    path: '/qingsu/abtest',
    component: qingsuAbtest
  },
  {
    path: '/qingsu/inviteWithGift',
    component: inviteWithGift
  },
  {
    path: '/qingsu/inviteList',
    component: inviteList
  },
  {
    path: '/qingsu/qingsuFinish',
    component: qingsuFinish
  },
  {
    path: '/qingsu/coupon/teacher',
    component: couponTeacher
  },
  {
    path: '/qingsu/qingsuFeedback',
    component: qingsuFeedback,
    meta: {
      pageName: '倾听小记',
      business: '倾诉'
    }
  },
  {
    path: '/qingsu/package/teacher',
    component: packageTeacher
  }
]
